import PropTypes from 'prop-types';
import { SFEntityID, dateInFormat } from 'utils/types';

// IntakeSerializedDateFormat is the date format used internal to the intake Javascript code.
// This date format is for serialized text → date parsing, not for display to humans
export const IntakeSerializedDateFormat = 'YYYY-MM-DD';

export const SearchingUserPermissions = PropTypes.shape({
  cohortsEnabled: PropTypes.bool.isRequired
});

export const IntakeMultipleChoiceString = PropTypes.arrayOf(PropTypes.string);
export const IntakeMultipleChoiceNumber = PropTypes.arrayOf(PropTypes.number);
export const IntakeBoolean = PropTypes.arrayOf(PropTypes.bool);
export const IntakeDateString = dateInFormat(IntakeSerializedDateFormat);

export const IntakeDate = PropTypes.oneOfType([
  PropTypes.instanceOf(Date),
  IntakeDateString
]);

export const IntakeDateRange = PropTypes.shape({
  start: IntakeDate.isRequired,
  end: IntakeDate.isRequired,
});

export const IntakeNumeric = PropTypes.shape({
  operator: PropTypes.oneOf(['=', '<=', '>=']).isRequired,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
});

export const IntakeFilterAnswer = PropTypes.oneOfType([
  IntakeBoolean,
  IntakeMultipleChoiceString,
  IntakeMultipleChoiceNumber,
  IntakeDateRange,
  IntakeNumeric,
]);

export const IntakeFilterAnswerType = PropTypes.oneOf([
  'TEXT',
  'YES_NO',
  'RADIO_STRING',
  'MULTI_STRING',
  'ONE_TO_FIVE',
  'FULL_DATE',
  'MONTH_YEAR',
  'DECIMAL'
]);

export const ActiveIntakeFilter = PropTypes.shape({
  questionId: SFEntityID.isRequired,
  type: IntakeFilterAnswerType.isRequired,
  value: IntakeFilterAnswer.isRequired,
});

export const IntakeQuestion = PropTypes.shape({
  id: SFEntityID.isRequired,
  type: IntakeFilterAnswerType.isRequired,
  text: PropTypes.string.isRequired,
});
